<ng-container *transloco="let t">
    <h2 tuiDialogHeading>
        <label>{{ t('order_qrcode') }}</label>
    </h2>

    <div class="text-center">
        <us-order-qrcode [order]="order"></us-order-qrcode>

        <p class="text-xl text-medium font-gray-800">
            {{ order.order_code }}
        </p>
    </div>
</ng-container>
